import { render } from "./OcrUploadPanel.vue?vue&type=template&id=0e8d61b7"
import script from "./OcrUploadPanel.vue?vue&type=script&lang=js"
export * from "./OcrUploadPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__